import { toTitleCase } from "../../../../Utils/stringUtls";

const FraudManagmentOverview = ({ data }) => {
  const {
    of_fm_service_type,
    of_fm_company_name,
    of_fm_contact_name,
    of_fm_job_title,
    of_fm_phone_number,
    of_fm_country,
    of_fm_email,
  } = data["6_0"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <div className="fw-700 font-bold">Fraud Management Service </div>
          <div>
            {of_fm_service_type?.length ? toTitleCase(of_fm_service_type) : "-"}
          </div>
        </div>
        {of_fm_service_type === "other" && (
          <>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Company Name</div>
              <div className="overview-val-text">
                {of_fm_company_name?.length
                  ? toTitleCase(of_fm_company_name)
                  : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Contact Name</div>
              <div className="overview-val-text">
                {of_fm_contact_name?.length
                  ? toTitleCase(of_fm_contact_name)
                  : "-"}
              </div>
            </div>

            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Job Title</div>
              <div className="overview-val-text">
                {of_fm_job_title?.length ? toTitleCase(of_fm_job_title) : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Company Phone</div>
              <div className="overview-val-text">
                {of_fm_phone_number?.length
                  ? toTitleCase(of_fm_phone_number)
                  : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">Email</div>
              <div className="overview-val-text">
                {of_fm_email?.length ? toTitleCase(of_fm_email) : "-"}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default FraudManagmentOverview;
